export default class modal {
    constructor(effect){

        this.$container;
        this.$overlay;
        this.$trigger;
        this.$content;
        this.$close;

        this.status = {
            select : "",
            mode : "close"
        }
        this.deviceSize;

    }
    init(scroll){

        this.$container = document.getElementById("c-modal");
        this.$overlay = document.getElementById("c-modal-overlay");
        this.$trigger = document.querySelectorAll(".js__modal-trigger");
        this.$content = this.$container.querySelectorAll(".c-modal-cont");
        this.$close = document.getElementById("c-modal-close");

        TweenMax.set(this.$overlay,{
            y : 110 + "%",
        });
        TweenMax.set(this.$content,{
            y : 50,
            opacity:0,
            display:'none',
        })
        TweenMax.set(this.$close.querySelectorAll(".line-color"),{
            x : -110 + "%",
        });


        for(let i in this.$trigger){
            if(this.$trigger[i].nodeType!==1) break;
            this.$trigger[i].addEventListener("click",(e)=>{

                let _$t = e.target,
                    _select = _$t.querySelectorAll("a")[0].getAttribute("href").replace(/#/g,"");

                if(this.status.mode == "open") return;

                this.status.select = _select;
                this.status.mode = "open";

                scroll.changeMode("modal",this.$container);
                this.mot();

            });
        }

        this.$overlay.addEventListener("click",(e)=>{


            if(this.status.mode == "close") return;

            this.status.mode = "close";
            scroll.changeMode("normal");
            this.mot();

        });
        this.$close.addEventListener("click",(e)=>{


            if(this.status.mode == "close") return;

            this.status.mode = "close";
            scroll.changeMode("normal");
            this.mot();

        });

    }

    mot(){

        if(this.status.mode=="open"){
            this.$container.classList.add("is-active");

            TweenMax.to(this.$overlay,0.6,{
                y : 0 + "%",
                onComplete:()=>{
                }
            })
            TweenMax.to(document.getElementById(this.status.select),0.6,{
                y : 0,
                opacity:1,
                display:'block',
                delay:0.2,
                onComplete:()=>{
                    TweenMax.staggerTo(this.$close.querySelectorAll(".line-color"),0.6,{
                        x : 0 + "%",
                    },0.1);

                }
            })



        }else{
            this.$container.classList.remove("is-active");

            TweenMax.staggerTo(this.$close.querySelectorAll(".line-color"),0.6,{
                x : 110 + "%",
            },0.1);

            TweenMax.to(this.$overlay,0.6,{
                y : 110 + "%",
                onComplete:()=>{
                }
            })
            TweenMax.to(document.getElementById(this.status.select),0.6,{
                y : 50,
                opacity:0,
                display:'none',
                onComplete:()=>{
                }
            })

        }


    }

    resize(deviceSize){

        if(deviceSize !== this.deviceSize) {
            this.deviceSize = deviceSize;
        }


    }
}
